import React from "react";
import { Link } from "react-router-dom";
import { Globe, Phone } from "lucide-react";
import { topBarLinks, companyInfo } from "../data/mock";

const TopBar = () => {
  return (
    <>
      <div className="bg-[#C9A227] text-black text-sm hidden md:block">
        <div className="max-w-[1400px] mx-auto px-6 py-2.5 flex items-center justify-between">
          <div className="flex items-center gap-8">
            {topBarLinks.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                className="hover:underline underline-offset-4 transition-colors font-medium tracking-tight"
              >
                {link.label}
              </Link>
            ))}
          </div>
          <div className="flex items-center gap-1.5 font-medium">
            <Globe className="w-4 h-4" />
            <span>France</span>
          </div>
        </div>
      </div>
      <a
        href={`tel:${companyInfo.emergencyPhone.replace(/\s/g, "")}`}
        className="block bg-[#123B2E] text-center py-3 px-4 hover:bg-[#1B4D3C] transition-colors"
        data-testid="topbar-big-phone"
      >
        <span className="inline-flex items-center gap-3 flex-wrap justify-center">
          <Phone className="w-7 h-7 text-[#C9A227]" />
          <span className="text-white text-lg sm:text-xl font-bold">Dépannage 24h/24 :</span>
          <span className="text-[#C9A227] text-3xl sm:text-4xl font-black tracking-wide tabular-nums">
            {companyInfo.emergencyPhone}
          </span>
        </span>
      </a>
    </>
  );
};

export default TopBar;
